import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Link } from "react-router-dom";
import { SimpleLoading, PromotionalFooterPure } from "../../pures";
import ConfigurationContractsHistoryPanelPure from "../../pures/configuration-contracts-history-panel/configuration-contracts-history-panel.pure";
import "./configuration-contracts-history.css";

import {
  SearchBarHLPure,
  ButtonHLPure,
  HeaderHLPure,
} from "../../pures";

const ConfigurationContractsHistoryView = (props) => {
  const { t } = useTranslation();
  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    boxShadow: "1px 1px 3px #959595",
    paddingTop: "10px",
    width: "auto",
  };

  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          spacing={4}
          className="configurationContractsHistoryView-container"
        >
          <Grid
            container
            className="configurationContractsHistoryView-body"
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          >
            <>
              <Grid
                item
                lg={12}
                md={12}
                xs={12}
                sm={12}
                className="configurationContractsHistoryView-header"
              >
                <HeaderHLPure
                  title={t("configurationContractsHistoryView.titleContractsHistory")}
                />
              </Grid>
              {/*Container primera seccion de items, fila*/}
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="configurationContractsHistoryView-navbar"
              >
                {/*Cada componente puro, estara envuelto en un grid item */}
                <Grid
                  item
                  lg={4}
                  md={4}
                  xs={12}
                  sm={12}
                  className="configurationContractsHistoryView-buttonHLPure"
                >
                  {  /* <ButtonAddHLPure
                    nameBtn="Agregar invitado"
                    iconAdd

                  />*/}
                </Grid>
                <Grid
                  item
                  lg={5}
                  md={4}
                  xs={12}
                  sm={12}
                  className="configurationContractsHistoryView-searchHLPure"
                >
                  <SearchBarHLPure
                    placeholder="Buscar por cliente"
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={4}
                  xs={12}
                  sm={12}
                  className="configurationContractsHistoryView-filterHLPure "
                >

                  {/*<SearchBarHLPure
                  />*/}
                  {/*<FilterHLPure
                    labelFilter={t("businessAdministrationPanelView.filter.by")}
                    nameOption="status"
                    optionsValue={t("businessAdministrationPanelView.options.all")}
                  />*/}
                </Grid>
              </Grid>
              <Grid

                className="configurationContractsHistoryView-gridContainer"
              >
                <ConfigurationContractsHistoryPanelPure {...props} />
              </Grid>
            </>

            <Grid
              container
              style={{ justifyContent: "flex-end" }}
            >
              <Link to="/configuration">
                <ButtonHLPure
                  nameBtn={t("button.return")}
                />
              </Link>
            </Grid>

            <Grid item xs={12} lg={12} md={12} sm={12}>
              <PromotionalFooterPure />
            </Grid>
          </Grid>
        </Container>
      )}
    </div>

  );
};

export { ConfigurationContractsHistoryView as default };
